import { HTMLAttributes, ReactNode, useRef } from 'react';
import { useRouter } from 'next/router';
import useViewportEnter from '@hooks/useViewportEnter';
import { trackViewComponent } from '_utils/GA4/trackViewComponent';
import type { ViewTracking } from '../viewComponentTracking';

interface TrackedSliceSectionProps extends HTMLAttributes<HTMLElement> {
  tracking: ViewTracking | null;
  children: ReactNode;
}

const TrackedSection = ({
  tracking,
  children,
  ...sectionProps
}: TrackedSliceSectionProps & { tracking: ViewTracking }) => {
  const ref = useRef<HTMLElement | null>(null);
  const pagePath = useRouter().asPath.split(/[?#]/)[0];

  useViewportEnter(
    ref,
    () =>
      trackViewComponent({
        interactionLocation: tracking.location,
        type: tracking.type,
        heading: tracking.heading,
        eventPage: window.location.pathname,
        index: tracking.index,
      }),
    pagePath
  );

  return (
    <section ref={ref} {...sectionProps}>
      {children}
    </section>
  );
};

const TrackedSliceSection = ({
  tracking,
  children,
  ...sectionProps
}: TrackedSliceSectionProps) =>
  tracking ? (
    <TrackedSection tracking={tracking} {...sectionProps}>
      {children}
    </TrackedSection>
  ) : (
    <section {...sectionProps}>{children}</section>
  );

export default TrackedSliceSection;
